import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { getCurLevelInfo } from '@core/api/oj/incentive';
import type { CurrentLevelInfoVO } from '@core/types/incentive';
import { StorageService } from './storage.service';

@Injectable()
export class LevelService {
  public level = {} as CurrentLevelInfoVO;

  @Inject(forwardRef(() => StorageService))
  public storageService!: StorageService;

  /**
   * 页面加载时通过init来初始化level，并更新缓存
   */
  public init() {
    this.initFromLocal();
    this.updateFromRemote();
  }

  /**
   * 当领取奖励时，或者升级时，需要调用此方法来更新level
   * 当前服务不提供更新单个字段的方法，统一通过后端接口获取最新数据
   */
  public updateFromRemote() {
    getCurLevelInfo().then((res) => {
      if (res) {
        this.level = res;
        this.saveToLocal(res);
      }
    });
  }

  private initFromLocal() {
    const level = this.storageService.getUserLevel();
    if (level) {
      this.level = level;
    }
  }

  private saveToLocal(level: CurrentLevelInfoVO) {
    this.storageService.setUserLevel(level);
  }
}
